export default __webpack_public_path__ + "static/media/daylotts_responsible_gambling.97d403fb.pdf";